export default "__VITE_ASSET__94c6a857__"